import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class RfpMessageService extends BaseService {

    static url = "rfp_messages";
    static apis = {
       
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("rfp_messages");
    }

}

export default RfpMessageService;